import constDevice from '@/utils/device.js'

const constGlobal = {
  isWeChat: () => {
    return constDevice.wechat()
  },
  isAndroid: () => {
    return constDevice.android()
  },
  isIOS: () => {
    return constDevice.ios()
  },
  isDebugger: () => {
    return false
  }
}

export default constGlobal



// WEBPACK FOOTER //
// ./src/utils/constGlobal.js